<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="bk">
<h1 class="bk"><a class="page" id="pii"></a><a class="page" id="piii"></a>Modernity and the Jews in Western Social Thought</h1>
<p class="bkau"><span class="sm">CHAD</span> <span class="sm">ALAN</span> <span class="sm">GOLDBERG</span></p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1"><span class="sm">CHICAGO</span> <span class="sm">&amp;</span> <span class="sm">LONDON</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Goldberg-0003.vue?b96578c2